import { useState, useRef, useEffect } from 'react';

import { DownArrowIcon } from '@assets/icons';

import SearchBarInput from '../SearchBarInput';
import { SearchInput, SearchResultError } from './SearchBarSearchInputStyle';
import { SearchBarSearchInputProps } from './SearchBarSearchInputInterface';

const SearchBarSearchInput = ({
  tourStyle,
  tourListing,
  isFlight,
  SearchResultListComponent,
  isBookerSearch = false, // used to not use react-tiny-popover (specific to the booker component)
  inputProps: {
    placeholder = 'Ara...',
    value: searchInputValue = '',
    onChange: onChangeInput,
    inputMode = 'none',
    onFocus,
  } = {},
  popoverProps = {},
  error,
  errorMessage,
  hasAnimationOnError,
  searchTextError,
  disabled = false,
  padding = '17px',
  isFlightIconShow,
  borderRadius,
  ...props
}: SearchBarSearchInputProps) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(false);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOverlayOpen) {
      inputRef.current?.focus();
    }
  }, [isOverlayOpen]);

  return (
    <SearchBarInput
      borderRadius={borderRadius}
      isFlight={isFlight}
      tourListing={tourListing}
      tourStyle={tourStyle}
      leftIcon={DownArrowIcon}
      isBookerSearch={isBookerSearch}
      wrapperPadding={padding}
      isFlightIconShow={isFlightIconShow}
      disabled={disabled}
      InputComponent={
        <SearchInput
          autoComplete='off'
          aria-label='search-input'
          onClick={(e) => {
            if (isOverlayOpen) {
              e.stopPropagation();
            }
            setIsOverlayOpen(true);
          }}
          value={searchInputValue}
          onChange={onChangeInput}
          placeholder={placeholder}
          ref={inputRef}
          inputMode={inputMode}
          onFocus={onFocus}
          disabled={disabled}
        />
      }
      error={error}
      errorMessage={errorMessage}
      hasAnimationOnError={hasAnimationOnError}
      isFilled={searchInputValue.toString().length > 0}
      popoverProps={{
        ...popoverProps,
        isOpen: isOverlayOpen,
        onVisibleChange: (visible) => {
          setIsOverlayOpen(visible);
        },
      }}
      renderOverlayContent={(closePopup) => {
        return searchTextError ? (
          <SearchResultError>
            Aradığınız kriterlere uygun sonuç bulunamadı.
          </SearchResultError>
        ) : (
          <SearchResultListComponent
            searchText={searchInputValue}
            onChange={(item: any = '') => {
              onChangeInput &&
                onChangeInput({
                  target: { value: item },
                } as any);
              closePopup();
            }}
          />
        );
      }}
      {...props}
    />
  );
};

export default SearchBarSearchInput;
